// React 開発版は境界で捕捉した例外とは別にコンポーネントスタックの説明を console.error する。
// 本体は元の Error として送られるので、今回の境界を示す説明メッセージだけを除く。
export const isReactErrorBoundaryConsoleEvent = (event: { logger?: string; message?: string }): boolean =>
  event.logger === "console" &&
  typeof event.message === "string" &&
  event.message.startsWith("The above error occurred in ") &&
  event.message.includes("AppErrorBoundary");
